import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgDataListComponent, ExgDataTableComponent, ExgModalService, ExgPopupComponent, ExgTableSettingsComponent} from 'exc-controls-v2';
import {ExgTabV2Component, ExgTabV2ComponentHeaderElement} from '../../misc/exg-tab-v2/exg-tab-v2.component';
import {ExcRestService, IExcDataDistinct, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ExgFilterComponent} from '../../misc/exg-filter/exg-filter.component';
import {ExgApplicationTabService} from 'exc-tab-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';
import {ExgFilterChipsComponent} from '../../misc/exg-filter-chips/exg-filter-chips.component';
import {ICaseSummaryData} from '../../misc/interfaces/ICaseSummaryData';
import {DataService} from '../../services/data.service';
import {NestedTreeControl} from '@angular/cdk/tree';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {ExcSecurityService} from 'exc-security-v2';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-case-list',
  templateUrl: './case-list.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class CaseListComponent
  extends ExcTranslation
  implements OnInit, AfterViewInit
{
  /****************************/
  @ViewChild('VCcaseTable', { read: ExgDataTableComponent })
  VCcaseTable!: ExgDataTableComponent;
  @ViewChild('VCcaseTableFilterControl', { read: ExgFilterComponent })
  VCcaseTableFilterControl!: ExgFilterComponent;
  @ViewChild('VCrightTabControl', { read: ExgTabV2Component })
  VCrightTabControl!: ExgTabV2Component;
  @ViewChild('VCtaskList', { read: ExgDataListComponent })
  VCtaskList!: ExgDataListComponent;
  @ViewChild('VCreceiptList', { read: ExgDataListComponent })
  VCreceiptList!: ExgDataListComponent;
  @ViewChild('VCreceiptListFilterControl', { read: ExgFilterComponent })
  VCreceiptListFilterControl!: ExgFilterComponent;
  @ViewChild('VCprocessTable', { read: ExgDataListComponent })
  VCprocessTable!: ExgDataListComponent;
  @ViewChild('VCcaseTablePrefilterPopup', { read: ExgPopupComponent })
  VCcaseTablePrefilterPopup!: ExgPopupComponent;
  @ViewChild('VCcasePagerFilterControl', { read: ExgFilterComponent })
  VCcasePagerFilterControl!: ExgFilterComponent;
  @ViewChild('VCcaseTableSearchControl', { read: ExgFilterComponent })
  VCcaseTableSearchControl!: ExgFilterComponent;
  @ViewChild('VCcaseTableSortControl', { read: ExgFilterComponent })
  VCcaseTableSortControl!: ExgFilterComponent;
  @ViewChild(ExgFilterChipsComponent) VCFilterChips!: ExgFilterChipsComponent;
  @ViewChild(ExgTableSettingsComponent) VCtableDefinitionSettings!: ExgTableSettingsComponent;
  /****************************/
  Events = new ExgApplicationEventEmitter();
  /****************************/
  preFilterDefinition: any[] = [];
  selectedMod: any;
  selectedType: any;
  rightDrawerVisible = false;
  rightTabs: ExgTabV2ComponentHeaderElement[] = [];
  init = true;
  tabinstance: any;
  vorgOeList = [] as any[];

  pendingLoading = true;
  caseTable = {
    selectKey: 'auID',
    newV2Table: false,
    prefilter: 0,
    state: 1,
    selectedRow: undefined as any,
    searchValue: '',
    uiFilterEnumGroup: [
      {
        enmName: 'Schadenart',
        enmField: 'aue_enmIdent_SchadenArt',
        enmTable: 'AuftragE_EIS',
        enmAlt: true,
        enmAltTT: true,
      },
      {
        enmName: 'AuftragStatus',
        enmField: 'au_enmIdent_AuftragStatus',
        enmTable: 'Auftrag',
      },
      {
        enmName: 'AuftragTyp',
        enmField: 'au_enmIdent_AuftragTyp',
        enmTable: 'Auftrag',
      },
      // {enmName: 'AuftragTyp', enmField: 'au_enmIdent_AuftragTyp', enmTable: 'Auftrag'}
    ],
    uiFilterSearchFields: [
      { table: 'Auftrag', tableField: 'auNr' },
      {
        table: 'Auftrag',
        tableField: 'auAuftraggeberShort',
        repColumn: 'au_oeID_Auftraggeber',
      },
      { table: 'All', tableField: 'auLCU', groupCaption: 'Auftrag' },
      { table: 'All', tableField: 'auLCD', groupCaption: 'Auftrag' },
      { table: 'All', tableField: 'auCKD', groupCaption: 'Auftrag' },
      { table: 'AuftragE_EIS', tableField: 'aueLetzterQSPruefer', groupCaption: 'Auftrag' },
      {
        table: 'AuftragE_EIS',
        tableField: 'aueSchadenNr',
        groupCaption: 'Schaden',
      },
      {
        table: 'AuftragE_EIS',
        tableField: 'aueVersicherungsnehmer',
        groupCaption: 'Schaden',
      },
      {
        table: 'AuftragE_EIS',
        tableField: 'aueSchadenOrt',
        groupCaption: 'Schaden',
      },
    ],
    uiSortFieldGroup: [
      { fieldGroup: 'Auftrag', fieldTable: 'All', fieldName: 'auLCD' },
      { fieldGroup: 'Auftrag', fieldTable: 'All', fieldName: 'auCRD' },
      { fieldGroup: 'Auftrag', fieldTable: 'All', fieldName: 'auCKD' },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueSchadenDatum',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueAuftragsdatum',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueOrtsterminPlan',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueOrtstermin',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueOrtstermin2',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueSchadenmeldungVU',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueFristverlaengerungBis',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueZwischenberichtDatum',
      },
    ],
    uiFilter: [] as any[],
    uiSort: [] as any[],
    uiSortAktiv(): any[] {
      return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
    },
    uiFilterAktiv(filterType?: number): any[] {
      return this.uiFilter
        .filter(
          (filters: any) =>
            !filterType || (filterType && filterType === filters.filterType)
        )
        .filter(
          (filters: any) =>
            (filters.uiValue === true && filters.filterType === 1) ||
            (filters.filterCondition.value.length > 0 &&
              filters.filterType === 2)
        );
    },
    data: [] as any[],
    tableDefinition: [] as any[],
    distinctData: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 24} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
      dataDistinct: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 24,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    isLoading: true,

    ready: () => {
      if (!this.caseTable.data || this.caseTable.data.length === 0) {
        this.caseTable.state = 2;
        if (this.VCcaseTable) {
          this.VCcaseTable.selectedRow = -1;
        }
      } else {
        this.caseTable.state = 0;
        if (this.VCcaseTable) {
          this.VCcaseTable.selectedRow = 0;
        }
      }
      this.init = false;
      this.caseTable.isLoading = false;
      this.tableIsLoading.next(this.caseTable.isLoading);
      this.VCFilterChips?.workspace.computeMetaInfo(
        this.appSvc.helperObj.clone(this.caseTable.MetaInfo)
      );
    },
    selectionChanged: (index: number) => {
      this.tableDrawerIsLoading.next(true);
      this.caseTable.selectedRow = this.caseTable.data[index];
      if (this.caseTable.selectedRow) {
        this.CaseSummary = this.dataSvc.Case.Summary.Get(
          this.caseTable.selectedRow.auID,
          undefined,
          { Events: this.Events }
        );
      }
    },
    pageChanged: (page: number) => {
      if (this.caseTable.MetaInfo.dataPaging !== undefined) {
        this.caseTable.MetaInfo.dataPaging.pageNo = page;
      }
      this.caseTable.loadData();
    },
    search: (value: string) => {
      this.caseTable.searchValue = value;
      this.caseTable.pageChanged(1);
    },
    loadData: () => {
      const SELF = this;
      SELF.caseTable.state = 1;
      SELF.caseTable.isLoading = true;
      SELF.pendingLoading = true;
      SELF.tableDrawerIsLoading.next(SELF.caseTable.isLoading);
      SELF.excRest
        .sget(
          SELF.excRest.computeUrl('CaseR_List', {
            filter: this.caseTable.prefilter,
            fts: this.caseTable?.searchValue,
          }),
          'caseListState',
          {
            MetaInfo: {
              dataPaging: this.caseTable.MetaInfo.dataPaging,
              dataSort: this.caseTable.MetaInfo.dataSort,
              dataFilter: this.caseTable.MetaInfo.dataFilter
            }
          }
        )
        .subscribe((response) => {
          if (response.success && response.data) {
            SELF.caseTable.data = response.data.Auftraege;
            SELF.caseTable.paging = response.paging.Auftraege;
          } else {
            SELF.caseTable.data = [];
            SELF.caseTable.paging = {
              pagingPage: 0,
              pagingEndRow: 0,
              pagingPageSize: 25,
              pagingTotalPages: 0,
              pagingTotalRows: 0,
              pagingStartRow: 0,
            };
          }
          SELF.caseTable.ready();
        });
    },
    getDistinctData: (dataDistinct: IExcDataDistinct) => {
      this.caseTable.MetaInfo.dataDistinct = dataDistinct;
      this.excRest
        .sget(
          this.excRest.computeUrl('CaseR_List', {
            filter: this.caseTable.prefilter,
            fts: this.caseTable?.searchValue,
          }),
          ExcCoreModule.Guid.NewGuid(),
          {MetaInfo: this.caseTable.MetaInfo}
        ).subscribe((ret: any) => {
        this.caseTable.distinctData = ret.data;
      });
    }
  };

  CaseSummary: ICaseSummaryData | any = this.dataSvc.Case.Summary.Get();

  config = {
    leistungList: {
      selectKey: 'leID',
      state: 1,
      searchValue: '',
      selectedRow: undefined as any,
      isLoading: false
    },
    receiptList: {
      treeControl: new NestedTreeControl<any>(node => node.receipts),
      selectKey: 'rcptID',
      state: 1,
      searchValue: '',
      selectedRow: undefined as any,
      uiFilterEnumGroup: [
        {enmName: 'ReceiptStatus', enmField: 'rcpt_enmIdent_ReceiptStatus', enmTable: 'Receipt'},
        {enmName: 'ReceiptTyp', enmField: 'rcpt_enmIdent_ReceiptType', enmTable: 'Receipt'},
        {
          enmName: 'Schadenart', enmField: 'aue_enmIdent_SchadenArt', enmTable: 'AuftragE_EIS', enmAlt: false,
          enmAltTT: true
        },
        {enmName: 'VorgangStatus', enmField: 'vorg_enmIdent_VorgangStatus', enmTable: 'Vorgang'},
        {enmName: 'VorgangTyp', enmField: 'vorg_enmIdent_VorgangTyp', enmTable: 'Vorgang'},
        {enmName: 'AuftragTyp', enmField: 'au_enmIdent_AuftragTyp', enmTable: 'Auftrag'}
      ],
      uiFilterSearchFields: [
        {tableField: 'vorgNr', table: 'Vorgang'},
        {tableField: 'Bearbeiter', table: 'Vorgang'},
        {tableField: 'Bearbeiter_Handy', table: 'Vorgang'},
        {tableField: 'vorgLCU', table: 'All', groupCaption: 'Vorgang'},
        {tableField: 'vorgLCD', table: 'All', groupCaption: 'Vorgang'},
        {groupCaption: 'Vorgang', table: 'All', tableField: 'vorgCKD'},
        {table: 'Vorgang', tableField: 'vorgFrist'},
        {tableField: 'aueSchadenNr', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
        {tableField: 'aueVersicherungsnehmer', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
        {tableField: 'aueSchadenOrt', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
        {tableField: 'auAuftraggeberShort', table: 'Auftrag', repColumn: 'au_oeID_Auftraggeber'},
        {tableField: 'auAnsprechpartner', table: 'Auftrag'},
      ],
      uiSortFieldGroup: [
        {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgLCD'},
        {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCRD'},
        {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCKD'},
        {fieldGroup: 'Vorgang', fieldTable: 'Vorgang', fieldName: 'vorgFrist'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenDatum'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueAuftragsdatum'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtsterminPlan'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin2'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenmeldungVU'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueFristverlaengerungBis'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueZwischenberichtDatum'},
      ],
      uiFilter: [] as any [],
      uiSort: [] as any [],
      uiSortAktiv(): any[] {
        return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
      },
      uiFilterAktiv(filterType?: number): any[] {
        return this.uiFilter
          .filter((filters: any) => filters.applied)
          .filter((filters: any) => !filterType || (filterType && filterType === filters.filterType));
      },
      hasChild: (_: number, node: any): boolean => {
        return !!node.receipts && node.receipts.length > 0;
      },
      paging: {
        pagingPage: 0,
        pagingEndRow: 0,
        pagingPageSize: 25,
        pagingTotalPages: 0,
        pagingTotalRows: 0,
        pagingStartRow: 0
      },
      isLoading: true,
      selectionChanged: (index: number) => {
        this.config.receiptList.selectedRow = this.CaseSummary.receiptList.data[index];
        this.chDecRefWakeUp();
      },
      pageChanged: (page: number) => {
        if (this.CaseSummary?.receiptList?.MetaInfo.dataPaging !== undefined) {
          this.CaseSummary.receiptList.MetaInfo.dataPaging.pageNo = page;
        }
        this.config.receiptList.loadData();
      },
      search(value: string): void {
        this.searchValue = value;
        this.loadData();
      },
      ready: () => {
        if (this.CaseSummary.receiptList.data.length === 0) {
          this.config.receiptList.state = 2;
          // this.VCreceiptList.selectedRow = -1;
        } else {
          this.config.receiptList.state = 0;
          // this.VCreceiptList.selectedRow = 0;
        }
        this.config.receiptList.isLoading = false;
        this.tableDrawerIsLoading.next(true);
      },
      loadData: (incomingData?: any, incomingPaging?: any) => {
        const SELF = this;
        if (!(incomingData && incomingPaging)) {
          SELF.config.receiptList.state = 1;
          SELF.config.receiptList.isLoading = true;
          SELF.excRest
            .get(
              SELF.excRest.computeUrl('ReceiptR_List', {
                fts: this.config.receiptList?.searchValue,
                vorgID: this.caseTable.selectedRow[this.caseTable.selectKey]
              }), {MetaInfo: SELF.CaseSummary.receiptList.MetaInfo})
            .subscribe(
              (data: any) => {
                if (data.success) {
                  SELF.CaseSummary.receiptList.loadData(data.data);
                }
                SELF.config.receiptList.ready();
              }
            );
        } else {
          SELF.CaseSummary.receiptList.loadData(incomingData);
        }
      },
      deleteReceipt: (event: any, rcptID: any, rcptUPT: any, rcptState: number) => {
        const SELF = this;

        event.preventDefault();
        event.stopPropagation();


        if (rcptState <= 2 || this.excSecurity.isFeatured('RECEIPTDELETE')) {
          SELF.modalSvc.showSimple(
            this.getRessource('DeleteReceipt.Title'),
            this.getRessource('DeleteReceipt.Message'),
            true,
            true,
            this.getGlobal('Delete'),
            this.getGlobal('Cancel')
          ).subscribe((rtVal: boolean) => {
            if (rtVal) {
              SELF.config.receiptList.state = 1;
              SELF.config.receiptList.isLoading = true;
              SELF.excRest
                .delete(SELF.excRest.computeUrl('ReceiptD', {rcptID}), {rcptUPT}, {})
                .subscribe((ret: any) => {
                  if (ret) {
                    this.modalSvc
                      .showToast(
                        ret.success
                          ? `${this.getGlobal('Success')} ${this.getGlobal('Delete')}`
                          : this.getGlobal('Cancel')
                        , `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`
                        , ret.success ? 'fal fa-trash-can-check' : 'fal fa-times-circle');
                    this.config.receiptList.loadData();
                  }
                });
            }
          });
        }
      }
    },
    flowTable: {
      state: 1,
      ready: () => {
        if (!this.CaseSummary?.flowTable.data || this.CaseSummary?.flowTable.data.length === 0) {
          this.config.flowTable.state = 2;
        } else {
          this.config.flowTable.state = 0;
        }
      },
    },
    attachmentJagTable: {
      state: 1,
      ready: () => {
        if (!this.CaseSummary?.attachmentJagTable.data || this.CaseSummary?.attachmentJagTable?.isEmpty) {
          this.config.attachmentJagTable.state = 2;
        } else {
          this.config.attachmentJagTable.state = 0;
        }
      },

      hasChild: (_: number, node: any): boolean => {
        return !!node.documents && node.documents.length > 0;
      },

      treeControl: new NestedTreeControl<any>(node => node.documents),
    },
    taskList: {
      selectKey: 'vorgID',
      state: 1,
      searchValue: '',
      selectedRow: undefined as any,
      uiFilterEnumGroup: [
        {
          enmName: 'ReceiptStatus',
          enmField: 'rcpt_enmIdent_ReceiptStatus',
          enmTable: 'Receipt',
        },
        {
          enmName: 'ReceiptTyp',
          enmField: 'rcpt_enmIdent_ReceiptType',
          enmTable: 'Receipt',
        },
        {
          enmName: 'Schadenart',
          enmField: 'aue_enmIdent_SchadenArt',
          enmTable: 'AuftragE_EIS',
          enmAlt: false,
        },
        {
          enmName: 'VorgangStatus',
          enmField: 'vorg_enmIdent_VorgangStatus',
          enmTable: 'Vorgang',
        },
        {
          enmName: 'VorgangTyp',
          enmField: 'vorg_enmIdent_VorgangTyp',
          enmTable: 'Vorgang',
        },
        {
          enmName: 'AuftragTyp',
          enmField: 'au_enmIdent_AuftragTyp',
          enmTable: 'Auftrag',
        },
      ],
      uiFilterSearchFields: [
        { tableField: 'vorgNr', table: 'Vorgang' },
        { tableField: 'Bearbeiter', table: 'Vorgang' },
        { tableField: 'Bearbeiter_Handy', table: 'Vorgang' },
        { tableField: 'vorgLCU', table: 'All', groupCaption: 'Vorgang' },
        { tableField: 'vorgLCD', table: 'All', groupCaption: 'Vorgang' },
        { groupCaption: 'Vorgang', table: 'All', tableField: 'vorgCKD' },
        { table: 'Vorgang', tableField: 'vorgFrist' },
        {
          tableField: 'aueSchadenNr',
          table: 'AuftragE_EIS',
          groupCaption: 'Schaden',
        },
        {
          tableField: 'aueVersicherungsnehmer',
          table: 'AuftragE_EIS',
          groupCaption: 'Schaden',
        },
        {
          tableField: 'aueSchadenOrt',
          table: 'AuftragE_EIS',
          groupCaption: 'Schaden',
        },
        {
          tableField: 'auAuftraggeberShort',
          table: 'Auftrag',
          repColumn: 'au_oeID_Auftraggeber',
        },
        { tableField: 'auAnsprechpartner', table: 'Auftrag' },
      ],
      uiSortFieldGroup: [
        { fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgLCD' },
        { fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCRD' },
        { fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCKD' },
        {
          fieldGroup: 'Vorgang',
          fieldTable: 'Vorgang',
          fieldName: 'vorgFrist',
        },
        {
          fieldGroup: 'Auftrag',
          fieldTable: 'AuftragE_EIS',
          fieldName: 'aueSchadenDatum',
        },
        {
          fieldGroup: 'Auftrag',
          fieldTable: 'AuftragE_EIS',
          fieldName: 'aueAuftragsdatum',
        },
        {
          fieldGroup: 'Auftrag',
          fieldTable: 'AuftragE_EIS',
          fieldName: 'aueOrtsterminPlan',
        },
        {
          fieldGroup: 'Auftrag',
          fieldTable: 'AuftragE_EIS',
          fieldName: 'aueOrtstermin',
        },
        {
          fieldGroup: 'Auftrag',
          fieldTable: 'AuftragE_EIS',
          fieldName: 'aueOrtstermin2',
        },
        {
          fieldGroup: 'Auftrag',
          fieldTable: 'AuftragE_EIS',
          fieldName: 'aueSchadenmeldungVU',
        },
        {
          fieldGroup: 'Auftrag',
          fieldTable: 'AuftragE_EIS',
          fieldName: 'aueFristverlaengerungBis',
        },
        {
          fieldGroup: 'Auftrag',
          fieldTable: 'AuftragE_EIS',
          fieldName: 'aueZwischenberichtDatum',
        },
      ],
      uiFilter: [] as any[],
      uiSort: [] as any[],
      uiSortAktiv(): any[] {
        return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
      },
      uiFilterAktiv(filterType?: number): any[] {
        return this.uiFilter
          .filter((filters: any) => filters.applied)
          .filter(
            (filters: any) =>
              !filterType || (filterType && filterType === filters.filterType)
          );
      },
      paging: {
        pagingPage: 0,
        pagingEndRow: 0,
        pagingPageSize: 25,
        pagingTotalPages: 0,
        pagingTotalRows: 0,
        pagingStartRow: 0,
      },
      isLoading: true,
      ready: () => {
        if (
          !this.CaseSummary?.taskList.data ||
          this.CaseSummary?.taskList?.isEmpty
        ) {
          this.config.taskList.state = 2;
          this.VCtaskList.selectedRow = -1;
        } else {
          this.config.taskList.state = 0;
          this.VCtaskList.selectedRow = 0;
        }
      },
      loadData: (incomingData?: any, incomingPaging?: any) => {
        const SELF = this;
        if (!(incomingData && incomingPaging)) {
          SELF.config.taskList.state = 1;
          SELF.config.taskList.isLoading = true;
          SELF.excRest
            .get(
              SELF.excRest.computeUrl('TaskR_List', {
                fts: this.config.taskList?.searchValue,
                vorgID: this.caseTable.selectedRow[this.caseTable.selectKey],
              }),
              { MetaInfo: SELF.CaseSummary.taskList.MetaInfo }
            )
            .subscribe((data: any) => {
              if (data.success) {
                SELF.CaseSummary.taskList.loadData(data.data, data.paging);
              }
              SELF.config.taskList.isLoading = false;
              SELF.config.taskList.ready();
            });
        } else {
          SELF.CaseSummary.taskList.loadData(incomingData, incomingPaging);
        }
      },
      selectedObjects: [] as any[],

      rowChange: (index: number) => {
        if (!this.config.taskList.selectedObjects.find((sOrt: any) => sOrt === this.CaseSummary?.taskList?.data[index])) {
          this.config.taskList.selectedObjects = [];
          this.config.taskList.selectedObjects.push(this.CaseSummary?.taskList?.data[index]);
        } else {
          this.VCtaskList.selectedRow = -1;
          this.config.taskList.selectedObjects = [];
        }
      },
      itemSelect: (index: number) => {
        if (this.config.taskList.selectedObjects.find((sOrt: any) => sOrt === this.CaseSummary?.taskList?.data[index])) {
          this.config.taskList.selectedObjects =
            this.config.taskList.selectedObjects.filter((sOrt: any) => sOrt !== this.CaseSummary?.taskList?.data[index]);
        } else {
          this.config.taskList.selectedObjects.push(this.CaseSummary?.taskList?.data[index]);
        }
      },
    },

    gdvReceiptList: {
      state: 1,
      ready: (): void => {
        if (!this.CaseSummary?.gdvReceiptList?.data || this.CaseSummary?.gdvReceiptList?.data.length === 0) {
          this.config.gdvReceiptList.state = 2;
        } else {
          this.config.gdvReceiptList.state = 0;
        }
      }
    },
    hasChild: (_: number, node: any): boolean => {
      return !!node.documents && node.documents.length > 0;
    },

    getOEByID: (ID: string): any => {
      return ExcCoreModule.Array.GetObject(
        this.CaseSummary?.oeList?.data,
        'oeID',
        ID
      );

    },

    treeControl: new NestedTreeControl<any>(node => node.documents),

    showAttachmentUpdateModal: (dokID: string): void => {
      this.appSvc.Document.Update.OpenModal({ dokID }, { Events: this.Events });
    },

    showAttachmentPreview: (dokID?: string): void => {
      this.appSvc.Document.Preview.OpenModal(
        { objID: this.CaseSummary?.ID, attID: dokID },
        { Events: this.Events }
      );
    },

    showAttachmentUploadModal: (): void => {
      if (this.CaseSummary?.ID) {
        this.appSvc.Document.Upload.OpenModal({dok_objID: this.CaseSummary?.ID}, {Events: this.Events});

      }
    },

    openReport: (rowID: any): void => {
      if (this.CaseSummary?.ID) {
        this.appSvc.Report.Open(rowID, {Events: this.Events});
      }
    },

    showHistory: (): void => {
      if (this.CaseSummary?.ID) {
        this.appSvc.History.OpenModal(this.CaseSummary?.historyTable?.data);
      }
    },

    newMessage: (): void => {
      if (this.CaseSummary?.ID) {
        this.appSvc.Message.NewForCase.OpenTab({objID: this.CaseSummary?.ID}, {Events: this.Events});
      }
    },

    newDefaultMessage: (dmsgID: any): void => {
      if (this.CaseSummary?.ID) {
        this.appSvc.Message.NewForCase.OpenTab({objID: this.CaseSummary?.ID, dmsgID}, {Events: this.Events});
      }
    },

    newServiceRecord: (): void => {
      this.appSvc.Leistungserfassung.New(
        {fkID: this.CaseSummary?.ID, fkType: 'Auftrag'},
        {Events: this.Events}
      );
    },

    newReport: (): void => {
      if (this.CaseSummary?.ID) {
        this.appSvc.Report.New(this.CaseSummary?.ID, {Events: this.Events});
      }
    },

    newNote: (): void => {
      if (this.CaseSummary?.ID) {
        this.appSvc.Note.OpenModal({ntz_objID: this.CaseSummary?.ID}, {Events: this.Events});
      }
    },
  };
  tableIsLoading = new BehaviorSubject(this.caseTable.isLoading);
  tableDrawerIsLoading = new BehaviorSubject(this.CaseSummary.isLoading);
  userType: any | number;

  openAttachmentFolder: string[] = [];


  getOEByID(ID?: string): any {
    return ExcCoreModule.Array.GetObject(
      this.CaseSummary.oeList.data,
      'oeID',
      ID
    );
  }

  constructor(
    private chDecRef: ChangeDetectorRef,
    private exgApplicationTabService: ExgApplicationTabService,
    public excRest: ExcRestService,
    public excSecurity: ExcSecurityService,
    private modalSvc: ExgModalService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService,
    private dataSvc: DataService
  ) {
    super();
    setInterval(() => {
      this.chDecRef.detectChanges();
    }, 15);
  }

  [key: string]: any;

  ngOnInit(): void {
    this.registerEvents();
    this.initialize();
    this.initTableDefinition();
  }

  ngAfterViewInit(): void {
    if (!this.selectedMod) {
      this.selectedMod = this.preFilterDefinition[0];
    }
    this.selectedType = this.selectedMod.types.find((i: any) => {
      return i.value === String(this.caseTable.prefilter);
    });
    this.VCcaseTableFilterControl.ApplyFilter();
  }

  registerEvents(): void {
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      if (this.exgApplicationTabService.StateTab?.Active) {
        this.caseTable.loadData();
      }
    });
    ExcCoreModule.Services().StrgI.subscribe(() => {
      if (this.exgApplicationTabService.StateTab?.Active) {
        this.rightDrawerVisible = !this.rightDrawerVisible;
      }
    });
    this.Events.Leistungserfassung?.New?.Save?.subscribe((evt: ExgEventArgs) => {
      this.tableDrawerIsLoading.next(true);
      this.CaseSummary?.LoadSummary();
    });
    this.Events.Message?.NewForTask?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.tableDrawerIsLoading.next(true);
      this.CaseSummary?.LoadSummary();
    });
    this.Events.NoteDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.tableDrawerIsLoading.next(true);
      this.CaseSummary?.LoadSummary();
    });
    this.Events.Receipt?.UploadDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.tableDrawerIsLoading.next(true);
      this.CaseSummary?.LoadSummary();
    });
    this.Events.Document?.UploadDialog?.Closed?.subscribe(
      (evt: ExgEventArgs) => {
        this.tableDrawerIsLoading.next(true);
        this.CaseSummary?.LoadSummary();
      }
    );
    this.Events.Document?.UpdateDialog?.Closed?.subscribe(
      (evt: ExgEventArgs) => {
        this.tableDrawerIsLoading.next(true);
        this.CaseSummary?.LoadSummary();
      }
    );
    this.Events.Case?.Summary?.DataLoaded?.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        this.config.receiptList.ready();
        // this.config.taskList.ready();
        this.config.flowTable.ready();
        this.config.attachmentJagTable.ready();
        this.config.gdvReceiptList.ready();
        this.buildRightTabs();
        this.pendingLoading = false;
      }
      this.tableDrawerIsLoading.next(false);
    });
    this.Events.Receipt?.Preview?.Downloaded?.subscribe((evt: ExgEventArgs) => {
      this.config.receiptList.isLoading = false;
    });
    this.enumSvc.repositoryLoaded.subscribe(() => {
      this.initEnumerations();
      this.initTableDefinition();
    });
    this.VCtableDefinitionSettings?.resetted.subscribe((evt: any) => {
      this.initTableDefinition();
    });
  }

  buildRightTabs(): void {
    const SELF = this;
    SELF.rightTabs = [
      {
        get caption(): string {
          return SELF.getResource('Tabs.Details.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Details.Icon');
        },
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Tasks.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Tasks.Icon');
        },
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Attachments.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Attachments.Icon');
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('DOCUMENTREAD');
        }
      },
    ];
    if (SELF.CaseSummary?.caseDetails?.data && SELF.CaseSummary?.caseDetails?.data?.showGDVActions) {
      SELF.rightTabs.push(
        {
          get caption(): string {
            return SELF.getResource('Tabs.GDVReceipt.HeaderText');
          },
          get icon_class(): string {
            return SELF.getResource('Tabs.GDVReceipt.Icon');
          },
          get disabled(): boolean {
            return !SELF.CaseSummary?.caseDetails?.data?.showGDVActions;
          }
        },
      );
    }
    SELF.rightTabs.push(
      {
        get caption(): string {
          return SELF.getResource('Tabs.Receipts.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Receipts.Icon');
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('RECEIPTREAD');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.ServiceRecords.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.ServiceRecords.Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Progress.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Progress.Icon');
        },
      }
    );
    if (SELF.VCrightTabControl) {
      this.VCrightTabControl._selectedtab = 0;
    }
    this.chDecRefWakeUp();
  }
  initialize(): void {
    const SELF = this;
    if (SELF.tabinstance) {
      SELF.tabinstance.Label = SELF.getRessource('Label');
    }
    SELF.userType = Number(SELF.appSvc.UserAttributes()?.type) || 2;
    SELF.initEnumerations();
    SELF. buildRightTabs();
    SELF.preFilterDefinition = [
      {
        value: 'active',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [
          {
            value: '1',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '2',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '3',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '4',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '7',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '9',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '0',
            get caption(): string {
              return SELF.getRessource('active.' + this.value);
            },
          },
        ],
      },
      {
        value: 'closed',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [
          {
            value: '51',
            get caption(): string {
              return SELF.getRessource('closed.' + this.value);
            },
          },
          {
            value: '52',
            get caption(): string {
              return SELF.getRessource('closed.' + this.value);
            },
          },
          {
            value: '53',
            get caption(): string {
              return SELF.getRessource('closed.' + this.value);
            },
          }
        ],
      },
      {
        value: 'cancelled',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [
          {
            value: '61',
            get caption(): string {
              return SELF.getRessource('cancelled.' + this.value);
            },
          },
          {
            value: '62',
            get caption(): string {
              return SELF.getRessource('cancelled.' + this.value);
            },
          },
          {
            value: '63',
            get caption(): string {
              return SELF.getRessource('cancelled.' + this.value);
            },
          }
        ],
      },
      {
        value: 'all',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [],
      },
    ];
    for (let i = new Date().getFullYear(); i >= new Date().getFullYear() - 3; i--)
    {
      SELF.preFilterDefinition[1].types.push(
        {
          value: '-5' + i,
          get caption(): string {
            return i as unknown as string;
          },
        }
      );
      SELF.preFilterDefinition[2].types.push(
        {
          value: '-6' + i,
          get caption(): string {
            return i as unknown as string;
          },
        }
      );
      SELF.preFilterDefinition[3].types.push(
        {
          value: '-1' + i,
          get caption(): string {
            return i as unknown as string;
          },
        }
      );
    }
    SELF.preFilterDefinition[1].types.push(
      {
        value: '5',
        get caption(): string {
          return SELF.getRessource('closed.' + this.value);
        },
      }
    );
    SELF.preFilterDefinition[2].types.push(
      {
        value: '6',
        get caption(): string {
          return SELF.getRessource('cancelled.' + this.value);
        },
      }
    );
    SELF.preFilterDefinition[3].types.push(
      {
        value: '-1',
        get caption(): string {
          return SELF.getRessource('all.' + this.value);
        },
      },
    );
  }

  initEnumerations(): void {
    this.caseTable.uiFilter = this.appSvc.metaInfo.dataFilter(
      this.caseTable.uiFilterEnumGroup,
      this.caseTable.uiFilterSearchFields
    );
    this.caseTable.uiSort = this.appSvc.metaInfo.dataSort(
      this.caseTable.uiSortFieldGroup
    );
  }

  initTableDefinition(): void {
    this.caseTable.tableDefinition = [
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'auNr')
        , value: 'auNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')
        , value: 'aueSchadenNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'aueVersicherungsnehmer')
        , value: 'aueVersicherungsnehmer'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenOrt')
        , value: 'aueSchadenOrt'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'au_oeID_Auftraggeber')
        , value: 'Auftraggeber_Name'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'au_enmIdent_AuftragStatus')
        , value: 'au_enmIdent_AuftragStatus'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('AuftragStatus', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'au_enmIdent_AuftragTyp')
        , value: 'au_enmIdent_AuftragTyp'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('AuftragTyp', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_SchadenArt')
        , value: 'aue_enmIdent_SchadenArt'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('Schadenart', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_Versicherungsart')
        , value: 'aue_enmIdent_Versicherungsart'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('Versicherungsart', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueLetzterSachverstaendiger')
        , value: 'aueLetzterSachverstaendiger'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueLetzterQSPruefer')
        , value: 'aueLetzterQSPruefer'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueOrtstermin')
        , value: 'aueOrtstermin'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueOrtstermin2')
        , value: 'aueOrtstermin2'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueOrtstermin2')
        , value: 'aueOrtsterminPlan'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date'
        , dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueKontaktaufnahmeVersuche')
        , value: 'contactAttempt'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%CKU')
        , value: 'auCKU'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%CKD')
        , value: 'auCKD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%LCU')
        , value: 'auLCU'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%LCD')
        , value: 'auLCD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueAbrechnungshinweis_enmIdent')
        , value: 'aueAbrechnungshinweis_enmIdent'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return value ? this.enumSvc.getEnumerationText('Abrechnungshinweis', value) : '';
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueAbschlussdatum')
        , value: 'aueAbschlussdatum'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
    ];
  }

  changePreFilterMod(event: any): void {
    this.selectedMod = event;
    // this.messageTable.prefilterMod = event.value;
    this.changePreFilterType(this.selectedMod.types[0]);
  }

  changePreFilterType(event: any): void {
    this.selectedType = event;
    this.caseTable.prefilter = event.value;
    this.VCcaseTableFilterControl.ApplyFilter();
  }

  toggleRightDrawer(): void {
    this.chDecRef.reattach();
    this.rightDrawerVisible = !this.rightDrawerVisible;

    if (this.rightDrawerVisible && this.caseTable.selectedRow) {
      this.CaseSummary = this.dataSvc.Case.Summary.Get(
        this.caseTable.selectedRow.auID,
        undefined,
        { Events: this.Events }
      );
    }
  }

  async openWorkspace(index?: number): Promise<void> {
    let caseRow = this.caseTable.selectedRow[this.caseTable.selectKey];
    let caseState = this.caseTable.selectedRow.au_enmIdent_AuftragStatus;
    if (index) {
      // For DblClick
      caseRow = this.caseTable.data[index][this.caseTable.selectKey];
      caseState = this.caseTable.data[index].au_enmIdent_AuftragStatus;
      await new Promise(f => setTimeout(f, 150));
    }
    if (caseRow && caseState !== 0) {
      if (this.excSecurity.isFeatured('CASEREAD')) {
        this.appSvc.Case.Workspace.OpenTab(caseRow, {Events: this.Events});
      } else {
        this.modalSvc.showToast('Sie sind nicht berechtigt die Auftragdetails zu öffnen!', 'md-toast', 'fas fa-exclamation');
      }
    }
    else if (caseRow && caseState === 0) {
      this.openCaseCreatorTab(caseRow);
    }
  }

  async openWorkspaceV2(index?: number): Promise<void> {
    let caseRow = this.caseTable.selectedRow[this.caseTable.selectKey];
    let caseState = this.caseTable.selectedRow.au_enmIdent_AuftragStatus;
    if (index) {
      // For DblClick
      caseRow = this.caseTable.data[index][this.caseTable.selectKey];
      caseState = this.caseTable.data[index].au_enmIdent_AuftragStatus;
      await new Promise(f => setTimeout(f, 150));
    }
    if (caseRow && caseState !== 0) {
      if (this.excSecurity.isFeatured('CASEREAD')) {
        this.appSvc.Case.Workspace.OpenTabV2(caseRow, {Events: this.Events});
      } else {
        this.modalSvc.showToast('Sie sind nicht berechtigt die Auftragdetails zu öffnen!', 'md-toast', 'fas fa-exclamation');
      }
    }
    else if (caseRow && caseState === 0) {
      this.openCaseCreatorTab(caseRow);
    }
  }

  rightTabs_tabChange($event: number): void {
    switch ($event) {
      case 0:
        break;
      case 1:
        break;
      case 2:
        this.config.receiptList.ready();
        break;
      default:
        break;
    }
    this.chDecRefWakeUp();
  }

  chDecRefWakeUp(): void {
    this.tableDrawerIsLoading.next(false);
  }

  OpenDetailHistoryModal(): void {
    if (!this.caseTable.isLoading
      && this.caseTable.selectedRow[this.caseTable.selectKey]) {
      this.modalSvc
        .show('ModalDetailHistoryComponent', {ID: this.caseTable.selectedRow[this.caseTable.selectKey]})
        .subscribe(() => {});
    }
  }

  openTableSettings($event: any): void {
    if (this.caseTable.newV2Table) {
      this.VCtableDefinitionSettings.openFilterConfig($event);
    }
  }

  onClickOpenTaskCheckview(task: any): void {
    if (this.excSecurity.isFeatured('TASKREAD')) {
      this.appSvc.Task.Workspace.OpenTabV2(task.vorgID);
    }
  }

  openReportBuilder(): void {
    this.appSvc.ReportBuilder.DocBuilder.OpenTab(
      {auID: this.CaseSummary?.caseDetails?.data?.auID, Events: this.Events});
  }

  createNewTask(): void {
    this.appSvc.Case.NewTask.OpenTab(
      {auID: this.CaseSummary?.ID},
      {Events: this.Events}
    );
  }

  openCaseCreatorTab(auID: string = ''): void {
    if ((!auID && !this.excSecurity.isFeatured('CASECREATE'))
      || auID && !this.excSecurity.isFeatured('CASEEDIT')) {
      this.modalSvc.showToast('Sie sind nicht berechtigt die Auftragserstellung zu öffnen!', 'md-toast', 'fas fa-exclamation');
      return;
    }
    this.appSvc.Case.NewCase.OpenTab(
      {
        auID, wert1914Faktor: this.CaseSummary.wert1914Faktor.isEmpty ? 0 : this.CaseSummary.wert1914Faktor.data
        , auNr: this.CaseSummary.caseDetails.data.auNr
      }, {Events: this.Events});
  }

  openFileOverview(): void {
    this.appSvc.Document.Manager.OpenOverlay({auID: this.caseTable.selectedRow[this.caseTable.selectKey], Events: this.Events});
  }
  /*openReportFolder: string[] = [];
  saveReportFolderStates(sources: string[]): void {
    this.openReportFolder = sources;
  }*/
  saveAttachmentFolderStates(sources: string[]): void {
    this.openAttachmentFolder = sources;
  }

  cloneSelectedCase(): void {
    const selectedCase = this.caseTable.selectedRow;
    if (!selectedCase || !selectedCase.auNr) {
      this.modalSvc.showToast(
        'Bitte wählen Sie zuerst einen Auftrag aus.',
        'md-toast bg-red',
        'fas fa-exclamation-circle'
      );
      return;
    }
    if (!this.excSecurity.isFeatured('CASECLONE')) {
      this.modalSvc.showToast(
        'Sie sind nicht berechtigt, einen Auftrag zu klonen.',
        'md-toast bg-red',
        'fas fa-exclamation-circle'
      );
      return;
    }
    this.modalSvc.showSimple(
      'Auftrag klonen',
      `Soll der Auftrag ${selectedCase.auNr} wirklich geklont werden?`,
      true,
      true,
      'Klonen',
      this.getGlobal('Cancel')
    ).subscribe((confirmed: boolean) => {
      if (!confirmed) {
        return;
      }
      const data = {
        CopyFromAuNr: selectedCase.auNr
      };
      this.excRest
        .post(
          this.excRest.computeUrl('CaseCloneC'),
          data
        )
        .subscribe((response: any) => {
          if (response && response.success) {
            const result = response.data?.[selectedCase.auID];
            const targetAuID = result?.TargetAuID;
            const targetAuNr = result?.TargetAuNr;
            this.modalSvc.showToast(
              targetAuNr
                ? `Der Auftrag wurde erfolgreich als ${targetAuNr} geklont.`
                : 'Der Auftrag wurde erfolgreich geklont.',
              'md-toast bg-green',
              'fas fa-check-circle'
            );
            this.caseTable.loadData();
            if (targetAuID) {
              this.appSvc.Case.Workspace.OpenTabV2(
                targetAuID,
                {Events: this.Events}
              );
            } else {
              this.modalSvc.showToast(
                'Der Auftrag wurde geklont, konnte aber nicht automatisch geöffnet werden.',
                'md-toast bg-red',
                'fas fa-exclamation-circle'
              );
            }
          } else {
            this.modalSvc.showToast(
              'Der Auftrag konnte nicht geklont werden.',
              'md-toast bg-red',
              'fas fa-exclamation-circle'
            );
          }
        });
    });
  }
}
